import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import PostJobContent from "../../components/jobBoard/PostJobContent";
import BackButton from "../../components/UIElements/BackButton";

const PostJob = () => {
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Jobs
            </Typography>
          </Stack>
        </Box>
      </Header>

      <PostJobContent />
    </>
  );
};

export default PostJob;
